'use strict';

var _classCallCheck = require("/home/circleci/repo/projects/idea-hub-client/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/circleci/repo/projects/idea-hub-client/node_modules/@babel/runtime/helpers/createClass");

var Wantlist = require('../types/wantlist');

var Ledger =
/*#__PURE__*/
function () {
  function Ledger(peerId) {
    _classCallCheck(this, Ledger);

    this.partner = peerId;
    this.wantlist = new Wantlist();
    this.exchangeCount = 0;
    this.sentToPeer = new Map();
    this.accounting = {
      bytesSent: 0,
      bytesRecv: 0
    };
  }

  _createClass(Ledger, [{
    key: "sentBytes",
    value: function sentBytes(n) {
      this.exchangeCount++;
      this.lastExchange = new Date().getTime();
      this.accounting.bytesSent += n;
    }
  }, {
    key: "receivedBytes",
    value: function receivedBytes(n) {
      this.exchangeCount++;
      this.lastExchange = new Date().getTime();
      this.accounting.bytesRecv += n;
    }
  }, {
    key: "wants",
    value: function wants(cid, priority) {
      this.wantlist.add(cid, priority);
    }
  }, {
    key: "cancelWant",
    value: function cancelWant(cid) {
      this.wantlist.remove(cid);
    }
  }, {
    key: "wantlistContains",
    value: function wantlistContains(cid) {
      return this.wantlist.contains(cid);
    }
  }, {
    key: "debtRatio",
    value: function debtRatio() {
      return this.accounting.bytesSent / (this.accounting.bytesRecv + 1); // +1 is to prevent division by zero
    }
  }]);

  return Ledger;
}();

module.exports = Ledger;